import 'slick-carousel';

export default class Carousel {

  constructor(props = {}) {
    this.carousel = $('.slick-carousel');

    if ( this.carousel ) {
      this.init({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 0,
        dots: true,
        arrows: true,
        ...props
      });
    }
  }

  init(props) {
    this.carousel.slick({
      prevArrow: '<button class="slick-arrow slick-prev fas fa-chevron-left" aria-label="Previous" type="button"></button>',
      nextArrow: '<button class="slick-arrow slick-next fas fa-chevron-right" aria-label="Next" type="button"></button>',
      ...props,
    });
  }
}
